import { initializeErrorReporting } from '@eventbrite/error-reporting';
import {
    getLocaleOverride,
    getParentLocale,
    setupAsync,
} from '@eventbrite/i18n';

import { datadogRum } from '@datadog/browser-rum-slim';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';
import { getSubApp } from './utils/http';

import { initDimensionsFromState } from '@eventbrite/site-analytics';
import React from 'react';
import { render } from 'react-dom';
import { App } from './app';

// retrieve data from server to hydrate on the client
const props = window.__SERVER_DATA__ || ({} as any);

const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const SAMPLE_RATE_MAP = {
    'things-to-do': 45,
    'points-of-interest': 100,
};

const currentEnv = getCurrentEnv(props);

const shouldUseDatadog = () => {
    return currentEnv === EBEnvs.PROD || currentEnv === EBEnvs.QA;
};

const initializeRum = () => {
    if (shouldUseDatadog() && window.location && window.location.pathname) {
        const subApp = getSubApp(window.location.pathname);
        const sampleRate =
            currentEnv == EBEnvs.PROD ? SAMPLE_RATE_MAP[subApp] : 100;

        initializeRealUserMonitoring({
            sessionSampleRate: sampleRate,
            version: props.app_version,
            service: props.app_name,
            env: currentEnv || undefined,
            enableExperimentalFeatures: ['feature_flags'],
        });

        datadogRum.onReady(() => {
            datadogRum.setGlobalContextProperty('view.sub_app', subApp);

            if (props?.user?.email) {
                const datadogRumUser = {
                    email: props.user.email,
                    id: props.user.publicId,
                };

                datadogRum.setUser(datadogRumUser);
            }
        });
    }
};

const main = async () => {
    initializeErrorReporting();
    initializeRum();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations: /* webpackChunkName: "i18n-translation" */ import(
                    `./i18n/translations/${parentLocale}.json`
                ),
            });
        }
    } finally {
        render(<App {...props} />, document.getElementById('root'));
    }
};

main();

initDimensionsFromState(props);
